import React, {useRef} from "react";
import Countdown from "react-countdown";
import { OTPInput } from "./OTPinput";


export function PinNumberPage({pinNumber, setPinNumber, timerCountdown}) {

    // const timerCountdown =  Date.now() + 300000;
    const textInputRef = useRef(null);

    function validatePin(text) {
        const regex = '^[0-9]*$';
        if(text.match(regex)){
          setPinNumber(text);
        }
      }

      function focusOnTextInput() {
          textInputRef.current.focus();
      }
      
      const renderer = ({ formatted: { hours, minutes, seconds }, completed }) => {
        if (completed) {
          // Render a completed state
          return <p className="timer">Code Expired</p>;
        } else {
          // Render a countdown
          return (
            <p className="timer">
              {minutes}:{seconds}
            </p>
          );
        }
      };

  return (
    <>
      <div>
        <p className="text-center">
          A verification code has been sent to your mobile. Your code will expire in:
          {timerCountdown > 0 &&
            <Countdown
              date={timerCountdown}
              renderer={renderer}
              zeroPadTime={2}
              zeroPadDays={2}
            />
          }
        </p>

        <input
          className="hidden-form-input"
          ref={textInputRef}
          value={pinNumber}
          onChange={(ev) => validatePin(ev.target.value)}
          maxLength={6}
          type="number"
          autoFocus
        />

        <div onClick={() => focusOnTextInput()}>
          <OTPInput pin={pinNumber} />
        </div>
      </div>
    </>
  );
}
